// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-sparklines-pies';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.656 2.808h14.616c.648 0 1.152.504 1.152 1.152v10.152c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V3.96c.072-.648.576-1.152 1.152-1.152z' />
    <path d='M9 13.104a4.104 4.104 0 1 0 0-8.208 4.104 4.104 0 0 0 0 8.208z' />
    <path d='M13.032 8.28 9 9V4.896M9 9l1.872 3.672' />
  </g>
);

export const viewBox = '0 0 18 18';
